/**
 * A thrown value as an `Error` with a string `message`. JavaScript can throw
 * anything — a library rejecting with a string or a plain object reaches an
 * error boundary as-is, and ErrorPage reading `.message.startsWith` on it
 * crashed the error page itself (FLASHKA-VITE-2CC).
 */
export function toError(value: unknown): Error {
  if (value instanceof Error && typeof value.message === 'string') return value;
  if (typeof value === 'string') return new Error(value);
  const message =
    value &&
    typeof value === 'object' &&
    typeof (value as { message?: unknown }).message === 'string'
      ? (value as { message: string }).message
      : String(value);
  return new Error(message);
}
